<template>
  <v-row  :align="align">
    <v-col :cols="cols" :class="classCol">
      <span>{{ title }}</span>
      <v-select
        dense
        outlined
        item-value="value"
        item-text="text"
        :disabled="disabled"
        :loading="loading"
        :items="$options.statuses"
        :value="getStatus"
        @change="$emit('status:change', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { statusList } from '@/configs/statuses'

export default {
  name: 'StatusPicker',
  props: {
    align: {
      type: String,
      default: 'center',
      validator (value) {
        return [
          'center',
          'start',
          'end',
          'space-between',
          'space-around',
          'stretch'
        ].includes(value)
      }
    },
    cols: {
      type: String,
      default: '6'
    },
    classCol: {
      type: String,
      default: 'pt-1'
    },
    title: {
      type: String,
      default: 'Статус:'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: statusList[0]?.title || ''
    }
  },
  statuses: statusList,
  computed: {
    getStatus () {
      return this.status || statusList[0]?.value || ''
    }
  },
  mounted () {
    this.$emit('status:change', this.getStatus)
  }
}
</script>
